var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"information-detail"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.info.content)},on:{"click":_vm.prviewPhoto}})])
}
var staticRenderFns = []

export { render, staticRenderFns }